import throwErrorIfTesting from "@insite/client-framework/Common/ThrowErrorIfTesting";
import {
    addToChainAfter,
    addToChainBefore,
    ApiHandlerDiscreteParameter,
    createHandlerChainRunnerOptionalParameter,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { addLineCollection } from "@insite/client-framework/Services/CartService";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { CartLineCollectionModel, CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import {
    chain,
    PopulateApiParameter,
    DispatchBeginReorder,
} from "@insite/client-framework/Store/Pages/OrderStatus/Handlers/Reorder";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";
import setShowRequisitionCartDisclaimer from "@tKgpco/Handlers/RequistionCart/Handlers/showRequisitionCartDisclaimer";
type HandlerType = ApiHandlerDiscreteParameter<HasOnSuccess, CartLineCollectionModel, CartLineCollectionModel>;

export const DispatchBeginReorderCustom: HandlerType = props => {
    const state = props.getState() as CustomApplicationState;

    if (state.KGPState.RequistionCartStore.isRequistionCartPresent) {
        props.dispatch(setShowRequisitionCartDisclaimer({ showDisclaimerForRequistionCart: true }));
        return false;
    }
};

addToChainBefore(chain, DispatchBeginReorder, DispatchBeginReorderCustom);
